import React from "react";
import FaceIcon from "@mui/icons-material/Face";
import Face3Icon from "@mui/icons-material/Face3";
import EventIcon from "@mui/icons-material/Event";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import SmokeFreeIcon from "@mui/icons-material/SmokeFree";
import SmokingRoomsIcon from "@mui/icons-material/SmokingRooms";
import LocalBarIcon from "@mui/icons-material/LocalBar";
import NoDrinksIcon from "@mui/icons-material/NoDrinks";
import ApartmentIcon from "@mui/icons-material/Apartment";
import CottageIcon from "@mui/icons-material/Cottage";
import PersonIcon from "@mui/icons-material/Person";
import PeopleIcon from "@mui/icons-material/People";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import DescriptionIcon from "@mui/icons-material/Description";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import SavingsIcon from "@mui/icons-material/Savings";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import BusinessIcon from "@mui/icons-material/Business";
import { Box, Chip, Grid, Stack, Typography } from "@mui/material";
import { withStyles } from "@mui/styles";
import { useStyles } from "./indexStyles";

const ChipSelect = (props) => {
  const {
    classes: { minWidth },
    classes,
    fieldname,
    handleChange,
    isMinWidth = false,
    selectedItem,
    disabled = false,
    disabledValue = null,
    rowIndex,
    padding = 1,
    paddingRight = 0.5,
  } = props;

  return (
    <Box>
      <Typography>{props.title}</Typography>
      <Grid container spacing={1} style={{ marginLeft: "-2px" }}>
        {props.options.map((item, index) => {
          return (
            <Box
              p={padding}
              pr={props.options.length - 1 === index ? 0 : paddingRight}
              key={item.value}
              className={props.width === "full" ? classes.fullWidth : ""}
              sx={{
                mt: index > 4 ? 0.5 : 0, // Add margin-top if index > 4
              }}
            >
              <Chip
                label={
                  <Box className={classes.label}>
                    <Stack
                      justifyContent="center"
                      alignItems="center"
                      direction="row"
                      gap={0.5}
                    >
                      {item.value === "Male" && <FaceIcon fontSize="medium" />}
                      {item.value === "Female" && (
                        <Face3Icon fontSize="medium" />
                      )}
                      {item.value === "Monthly" && (
                        <EventRepeatIcon fontSize="small" />
                      )}
                      {item.value === "Yearly" && (
                        <EventIcon fontSize="small" />
                      )}
                      {item.value === "Smoker" && (
                        <SmokingRoomsIcon fontSize="small" />
                      )}
                      {item.value === "Non Smoker" && (
                        <SmokeFreeIcon fontSize="small" />
                      )}
                      {item.value === "Alcohol" && (
                        <LocalBarIcon fontSize="small" />
                      )}
                      {item.value === "Non Alcohol" && (
                        <NoDrinksIcon fontSize="small" />
                      )}
                      {item.value === "Urban" && (
                        <ApartmentIcon fontSize="small" />
                      )}
                      {item.value === "Rural" && (
                        <CottageIcon fontSize="small" />
                      )}
                      {item.value === "Single" && (
                        <PersonIcon fontSize="small" />
                      )}
                      {item.value === "Married" && (
                        <PeopleIcon fontSize="small" />
                      )}
                      {item.value === "PAN" && (
                        <CreditCardIcon fontSize="small" />
                      )}
                      {item.value === "Form 60" && (
                        <DescriptionIcon fontSize="small" />
                      )}
                      {(item.value === "Yes" || item.value === "YES") && (
                        <CheckCircleIcon fontSize="small" />
                      )}
                      {(item.value === "No" || item.value === "NO") && (
                        <CancelIcon fontSize="small" />
                      )}
                      {item.value === "Savings" && (
                        <SavingsIcon fontSize="small" />
                      )}
                      {item.value === "Current" && (
                        <AccountBalanceIcon fontSize="small" />
                      )}
                      {/* {item.value === "Salaried" && (
                        <AccountBalanceIcon fontSize="small" />
                      )}
                      {item.value === "Self Employeed" && (
                        <AccountBalanceIcon fontSize="small" />
                      )} */}
                      <Typography variant="caption">{item.title}</Typography>
                      <Typography
                        className={
                          classes.wrap + " " + classes[props.fontWeight]
                        }
                      >
                        {item.subTitle}
                      </Typography>
                    </Stack>
                  </Box>
                }
                onClick={(e) => {
                  handleChange(fieldname, item.value, rowIndex);
                }}
                className={`${
                  (props.size === "large"
                    ? selectedItem == item.value
                      ? classes.activeChipLarge
                      : classes.chipLarge
                    : selectedItem == item.value
                    ? classes.activeChip
                    : classes.chip) +
                  " " +
                  (props.width === "full" && classes.fullWidth)
                } ${isMinWidth && minWidth}`}
                {...((disabled ||
                  item.value === disabledValue ||
                  item.disabled) && { disabled: true })}
              />
            </Box>
          );
        })}
      </Grid>
    </Box>
  );
};

export default withStyles(useStyles, { withTheme: true })(ChipSelect);
